import React from 'react';
import PropTypes from 'prop-types';

import { TranslatedTextMessage } from './TranslatedTextMessage';

const BlockedStateWarningText = ({ stateLabel }) => (
  <div className="age-gate__blocked-state-warning-text">
    <TranslatedTextMessage
      id={'BLOCKED_STATE_WARNING'}
      inlineData={{ state: stateLabel }}
    />
  </div>
);

BlockedStateWarningText.propTypes = {
  stateLabel: PropTypes.string.isRequired,
};

export default BlockedStateWarningText;
